import { z } from 'zod';
import type { GroceryClientInterface } from '@/service/groceries/groceryClient';

// Before groceries moved to Firestore, the persisted Pinia store kept the
// list in localStorage under this key
export const LEGACY_STORAGE_KEY = 'groceries';

const LegacyGroceriesSchema = z.object({
  groceries: z.object({
    list: z
      .array(
        z.object({
          text: z.string().default(''),
          done: z.boolean().default(false),
        }),
      )
      .default([]),
  }),
});

function legacyItems(raw: string) {
  try {
    return LegacyGroceriesSchema.parse(JSON.parse(raw)).groceries.list;
  } catch {
    return [];
  }
}

// Uploads the list this device kept locally, once, then forgets it.
// Returns the number of uploaded items.
export async function migrateLocalGroceries(
  client: Pick<GroceryClientInterface, 'add'>,
  storage: Storage,
): Promise<number> {
  const raw = storage.getItem(LEGACY_STORAGE_KEY);
  if (raw === null) {
    return 0;
  }
  const items = legacyItems(raw).filter(({ text }) => text.trim() !== '');
  const start = Date.now();
  for (const [index, { text, done }] of items.entries()) {
    // Consecutive timestamps keep the original order
    await client.add({ text, done, createdAt: start + index });
  }
  storage.removeItem(LEGACY_STORAGE_KEY);
  return items.length;
}
